import { render } from "./modal-download.vue?vue&type=template&id=e33bd54a&scoped=true&ts=true"
import script from "./modal-download.vue?vue&type=script&lang=ts"
export * from "./modal-download.vue?vue&type=script&lang=ts"

import "./modal-download.vue?vue&type=style&index=0&id=e33bd54a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e33bd54a"]])

export default __exports__